import { useApi } from '@repo-level/core-front';
import type { ICloverGoldPromo } from 'api/cms/cloverGoldPromo';
import { getCloverGoldPromo } from 'api/cms/cloverGoldPromo';
import type { FC } from 'react';
import { createContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ICloverGoldContext {
  cloverGoldData: ICloverGoldPromo | null;
  cloverGoldPending: boolean;
}

export const CloverGoldContext = createContext<ICloverGoldContext>({
  cloverGoldData: null,
  cloverGoldPending: false,
});

export const CloverGoldContextProvider: FC = ({ children }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const [requestCloverGold, { data: cloverGoldData, pending }] =
    useApi(getCloverGoldPromo);

  useEffect(() => {
    requestCloverGold(language);
  }, [language, requestCloverGold]);

  const contextValue = useMemo(
    () => ({
      cloverGoldData: cloverGoldData ?? null,
      cloverGoldPending: pending,
    }),
    [cloverGoldData, pending]
  );

  return (
    <CloverGoldContext.Provider value={contextValue}>
      {children}
    </CloverGoldContext.Provider>
  );
};
